<template>
  <div class="content">
    <table class="table is-narrow is-striped">
      <thead><tr><th colspan="2">{{user.name}} <em class="is-size-7">({{user.data.length}} öl provade)</em></th></tr></thead>
      <tbody>
        <tr v-for="(beer, beerIndex) in user.data.slice(0, itemsInList)" :key="beerIndex">
          <td><v-link :query="beer.name" showTitle="true" /></td>
          <td class="has-text-left top-favorite__rating">{{beer.rating}} <small>({{beer.average}})</small></td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2" class="has-text-right is-size-7 is-uppercase">
            <template v-if="user.data.length > 3">
              <span class="beers-in-list" v-show="itemsInList !== user.data.length">
                <a @click="beersInList(user.data.length)">Visa alla</a>&nbsp;&nbsp;
              </span>
              <span class="beers-in-list" v-if="user.data.length > 10" v-show="itemsInList !== 10">
                <a @click="beersInList(10)">Topp 10</a>&nbsp;&nbsp;
              </span>
              <span class="beers-in-list" v-show="itemsInList !== 3">
                <a @click="beersInList(3)">Topp 3</a>
              </span>
            </template>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
import VLink from '../VLink'

export default {
  components: {VLink},
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      itemsInList: 3
    }
  },
  methods: {
    beersInList: function (numb) {
      this.itemsInList = numb
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserBeers.vue?abec6612